// components/ProductElement.js
import React from 'react';

function ProductElement({ item, top, ventes, commission, produit, handleClick }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      onClick={() => handleClick(item)}
    >
      <div className="product_div">
        <div
          style={{
            width: "35%",
            height: "100%",
            backgroundImage: `url(${produit})`,
            backgroundSize: "cover",
            border: "5px solid #c2c2c2",
            borderRadius: "5px",
          }}
        />
        <div className="product_text_div">
          <h4 className="product_text">Top#{top}</h4>
          <h4 className="product_text">{ventes} ventes</h4>
          <h4 className="product_text">{commission} € Commission</h4>
        </div>
      </div>
      <div className="element_devider" />
    </div>
  );
}

export default ProductElement;
